import { render, staticRenderFns } from "./chatHeader.vue?vue&type=template&id=871504c4"
import script from "./chatHeader.vue?vue&type=script&lang=ts"
export * from "./chatHeader.vue?vue&type=script&lang=ts"
import style0 from "./chatHeader.vue?vue&type=style&index=0&id=871504c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports